import { Sparkles } from "lucide-react";

import { TOUR_FAKE_OUTPUT_TEXT, TOUR_VARIABLE_SET_NAME } from "./mocks";

/**
 * A static output card shown while the tour teaches output comparison.
 * It gives the walkthrough a believable result without making an LLM call.
 */
const PlaygroundTourFakeOutputCard = () => (
  <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
    <div className="flex items-center justify-between border-b border-gray-100 px-3 py-2">
      <div className="flex items-center gap-x-2">
        <Sparkles className="h-3.5 w-3.5 text-blue-500" />
        <span className="text-xs font-medium text-gray-700">{TOUR_VARIABLE_SET_NAME}</span>
        <span className="rounded-full bg-blue-50 px-1.5 py-0.5 text-[10px] font-medium text-blue-700">
          demo
        </span>
      </div>
      <span className="text-[10px] text-gray-400">387 tokens</span>
    </div>
    <div className="px-3 py-2">
      <div className="whitespace-pre-wrap text-xs leading-relaxed text-gray-700">
        {TOUR_FAKE_OUTPUT_TEXT}
      </div>
    </div>
  </div>
);

export default PlaygroundTourFakeOutputCard;
